import React, { useState } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { adminApi } from "../lib/api";

export const EnquiryNotification = ({ enquiry, reload }) => {
  const [busy, setBusy] = useState(false);
  if (!enquiry.event_id || !enquiry.notification_status) return null;
  async function retry() {
    setBusy(true);
    try {
      const { data } = await adminApi.post(`/admin/racex/enquiries/${enquiry.id}/retry`);
      if (data.status === "sent") toast.success("Staff notification sent");
      else toast.error("Email still failed. Please phone the customer directly.");
      reload();
    } catch { toast.error("Could not retry this notification. The enquiry remains saved."); }
    finally { setBusy(false); }
  }
  return enquiry.notification_status === "failed" ? <div className="mt-3 flex flex-wrap items-center gap-3 border border-red-400/40 bg-red-950/20 p-3 text-xs text-red-200" role="alert" data-testid={`enquiry-${enquiry.id}-email-failed`}><AlertTriangle size={16} /><span>Staff email failed. This enquiry is saved—phone the customer so the lead isn’t missed.</span><button disabled={busy} onClick={retry} className="flex items-center gap-2 underline disabled:opacity-50" data-testid={`enquiry-${enquiry.id}-retry-email-button`}><RotateCcw size={13} />{busy ? "Retrying…" : "Retry email"}</button></div> : <p className="mt-3 text-xs text-stone-300" data-testid={`enquiry-${enquiry.id}-email-status`}>Staff notification: {enquiry.notification_status}</p>;
};